import { useState } from "react";

import { pdf } from "@react-pdf/renderer";

import { ShipmentPDF } from "../components/Shipment/components/ShipmentPDF";

interface UsePDFExportProps {
  shipment: CondensedShipment;
  publicShipmentUrl?: string | null;
}

export function useShipmentPDFExport(props: UsePDFExportProps) {
  const { shipment, publicShipmentUrl } = props;
  const [isExporting, setIsExporting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const exportShipmentToPDF = async (
    sections: AppRenderedPDFSectionConfig[],
  ) => {
    setIsExporting(true);
    setError(null);
    try {
      const blob = await pdf(
        <ShipmentPDF
          shipment={shipment}
          sections={sections}
          publicShipmentUrl={publicShipmentUrl}
        />,
      ).toBlob();

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `shipment-${shipment.info.id}-export.pdf`;
      link.click();

      URL.revokeObjectURL(url);
    } catch (err) {
      setError("Failed to generate PDF. Please try again.");
      throw err;
    } finally {
      setIsExporting(false);
    }
  };

  return {
    exportShipmentToPDF,
    isExporting,
    error,
  };
}
